import { render, staticRenderFns } from "./PurchaseEditor.vue?vue&type=template&id=f3319dbc&"
import script from "./PurchaseEditor.vue?vue&type=script&lang=js&"
export * from "./PurchaseEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports